import React from 'react';
import styles from './counter.module.scss';

export default function Counter({ counter, setCounter, min = 0 }) {
  const increment = () => setCounter((c) => c + 1);
  const decrement = () => counter > min && setCounter((c) => c - 1);

  return (
    <div className={styles.buttonCounters}>
      <button type="button" className={styles.decrement} onClick={decrement}>
        -
      </button>
      <span className={styles.text}>{counter}</span>
      <button type="button" className={styles.increment} onClick={increment}>
        +
      </button>
    </div>
  );
}
